module.exports = __webpack_public_path__ + "img/JAOC_POP_AgedCheese_rectangular.fe242ef3.png";